import { lazy, Suspense } from "react";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import ComplimentMarquee from "./components/ComplimentMarquee";
import SubmitSection from "./components/SubmitSection";
import Counter from "./components/Counter";
import Footer from "./components/Footer";
import CoiledCord from "./components/CoiledCord";
import { COW_MODE } from "./config/cowMode";

const CowTakeoverLayer = lazy(() => import("./components/cow/CowTakeoverLayer"));

export default function App() {
  return (
    <main className="relative overflow-x-hidden">
      <Hero />
      <ComplimentMarquee />
      <CoiledCord cowPrint={COW_MODE} />
      <HowItWorks />
      <CoiledCord flipped cowPrint={COW_MODE} />
      <Counter />
      <SubmitSection />
      <Footer />
      {COW_MODE && (
        <Suspense fallback={null}>
          <CowTakeoverLayer />
        </Suspense>
      )}
    </main>
  );
}
